function isStyleVisible(element) {
  if (!(element instanceof HTMLElement) && !(element instanceof SVGElement)) {
    return false;
  }
  const { display, visibility } = element.style;
  let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
  if (isVisible) {
    const { getComputedStyle } = element.ownerDocument.defaultView;
    const { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
    isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
  }
  return isVisible;
}
function isAttributeVisible(element) {
  return !element.hasAttribute("hidden");
}
function isElementVisible(element) {
  return isStyleVisible(element) && isAttributeVisible(element) && (!element.parentElement || isElementVisible(element.parentElement));
}
const focusableElements = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "audio[controls]",
  "video[controls]"
];
const FOCUSABLE_ELEMENT_SELECTOR = focusableElements.join(":not([hidden]),") + ',[tabindex]:not([tabindex="-1"]):not([disabled]):not([hidden])';
function isElementFocusable(node) {
  if (node.matches(FOCUSABLE_ELEMENT_SELECTOR) && isElementVisible(node)) {
    return true;
  }
  return false;
}
function getFocusableTreeWalker(root) {
  const selector = FOCUSABLE_ELEMENT_SELECTOR;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
    acceptNode(node) {
      if (node.matches(selector) && isElementVisible(node)) {
        return NodeFilter.FILTER_ACCEPT;
      }
      return NodeFilter.FILTER_SKIP;
    }
  });
  return walker;
}
function executeForFirstFocusDescendant(node, callback) {
  const tree = getFocusableTreeWalker(node);
  let treeNode;
  while (treeNode = tree.nextNode()) {
    if (isElementFocusable(treeNode)) {
      callback(treeNode);
      break;
    }
  }
}
function executeForFocusDescendants(node, callback) {
  const tree = getFocusableTreeWalker(node);
  let focusable;
  while (focusable = tree.nextNode()) {
    callback(focusable);
  }
}
function safelyUnmountNodeAttr(node, attr) {
  if (node instanceof HTMLElement) {
    node.removeAttribute(attr);
  }
}
function safelyMountNodeAttr(node, attr, value) {
  if (node instanceof HTMLElement) {
    if (value !== void 0) {
      node.setAttribute(attr, value);
    }
  }
}
export {
  FOCUSABLE_ELEMENT_SELECTOR,
  executeForFirstFocusDescendant,
  executeForFocusDescendants,
  getFocusableTreeWalker,
  isAttributeVisible,
  isElementFocusable,
  isElementVisible,
  isStyleVisible,
  safelyMountNodeAttr,
  safelyUnmountNodeAttr
};
